import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-settings',
  templateUrl: './campaign-settings.component.html',
  styleUrls: ['./campaign-settings.component.scss']
})
export class CampaignSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
